module.exports = __webpack_public_path__ + "static/img/old.6e0e792.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/old.jpg
// module id = mGv7
// module chunks = 0